"use strict";

exports.__esModule = true;
exports.default = commalify;

function commalify(objects) {
  const parts = [];
  objects.forEach(element => {
    parts.push(element.name);
  });
  return parts.join(", ");
}